import {
    type ViewStyle,
    StyleSheet,
    Platform
} from "react-native";
import {
    type InputGroupDescriptionConstantType,
    type InputGroupIconColorConstantType,
    type InputGroupDynamicStyleType,
    type InputGroupSize
} from "./type";
import type {
    Mutable
} from "../../types";
import type {
    ControlSizeType
} from "../../types/theme";
import type {
    FieldInputAccessibilityType
} from "../fieldControl/type";

export const INPUT_GROUP_COMPACT_SIZES: Record<InputGroupSize, ControlSizeType> = {
    large: "medium",
    medium: "small",
    small: "small"
};

export const getInputGroupIconColor = ({
    isDisabled,
    colors
}: InputGroupIconColorConstantType): string => {
    if(isDisabled) {
        return colors.system.state.content.disabled.neutral;
    }

    return colors.content.icon.mid;
};

export const getInputGroupDescription = ({
    describedBy: describedByProp,
    accessibilityProps,
    hint: hintProp,
    textHints,
    counterID
}: InputGroupDescriptionConstantType): Pick<FieldInputAccessibilityType, "aria-describedby" | "accessibilityHint"> => {
    if(Platform.OS === "web") {
        const describedBy = [
            ...textHints.map((hint) => hint.id),
            accessibilityProps["aria-describedby"],
            counterID,
            describedByProp
        ].filter(Boolean).join(" ");

        return {
            "aria-describedby": describedBy || undefined
        };
    }

    const accessibilityHint = [
        ...textHints.map((hint) => hint.text),
        accessibilityProps.accessibilityHint,
        hintProp
    ].filter(Boolean).join(", ");

    return {
        accessibilityHint: accessibilityHint || undefined
    };
};

const stylesheet = StyleSheet.create({
    spinner: {
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0
    },
    textAreaContainer: {
        alignItems: "flex-start",
        flexDirection: "row",
        alignSelf: "stretch",
        flex: 1
    },
    stack: {
        flexDirection: "column",
        alignSelf: "stretch",
        flex: 1
    }
});

export const useStyles = ({
    currentSize,
    spaces
}: InputGroupDynamicStyleType) => {
    const styles = {
        textAreaSpinner: {
            marginTop: spaces.spacingSm + (currentSize.lineHeight - currentSize.iconSize) / 2,
            marginEnd: currentSize.paddingHorizontal
        } as Mutable<ViewStyle>,
        stack: {
            marginHorizontal: -currentSize.paddingHorizontal
        } as Mutable<ViewStyle>,
        spinner: {
            height: currentSize.iconSize,
            width: currentSize.iconSize
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
